import "./Footer.css";
import { Link } from "react-router-dom";

function Footer({
  termsLink = "/terms-of-service",
  privacyLink = "/privacy-policy",
}) {
  return (
    <>
      <footer className="info">
        <Link to={termsLink}>Terms of Service</Link>
        <Link to={privacyLink}>Privacy Policy</Link>
        <Link to={"/contact"}>Contact</Link>
        <Link to={"/donate"}>Donate</Link>
      </footer>
    </>
  );
}

export default Footer;
